'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFutbolO = function FaFutbolO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.6 18.2l6.4-4.6 6.4 4.6-2.4 7.5h-7.9z m6.4-18.2q4.1 0 7.8 1.6t6.4 4.2 4.2 6.4 1.6 7.8-1.6 7.8-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6z m13.8 30.1q3.3-4.5 3.3-10.1v-0.1l-2.2 2-5.4-5 1.4-7.2 3 0.3q-3.3-4.6-8.7-6.3l1.2 2.8-6.4 3.5-6.4-3.5 1.2-2.8q-5.4 1.7-8.7 6.3l3-0.3 1.4 7.2-5.4 5-2.2-2v0.1q0 5.6 3.3 10.1l0.7-2.9 7.2 0.9 3.1 6.6-2.6 1.6q2.7 0.8 5.4 0.8t5.4-0.8l-2.6-1.6 3.1-6.6 7.3-0.9z' })
        )
    );
};

exports.default = FaFutbolO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/futbol-o.js
// module id = 325
// module chunks = 61762850755587 79611799117203 213534597649335